import React from "react";
import ReactDOM from "react-dom";
import { X } from "lucide-react";
import MacroSplitEditor from "./MacroSplitEditor";

/**
 * Modal wrapper around MacroSplitEditor. Mount with `open` + `onOpenChange`.
 * Used by Dashboard, GoalsPage, and any other surface that wants a
 * one-tap-to-edit affordance for the user's macro split.
 *
 * Portaled to <body> via React.createPortal — without this the modal gets
 * trapped inside a transformed ancestor (e.g. the `.fade-up` entrance
 * animation on the parent page), which breaks `position: fixed` and makes
 * the panel render at the bottom of the document instead of the viewport.
 */
export default function MacroSplitModal({ open, onOpenChange, kcalTarget }) {
  if (!open) return null;
  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[55] flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={() => onOpenChange(false)}
      data-testid="macro-split-modal"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="relative w-full max-w-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={() => onOpenChange(false)}
          className="absolute -top-3 -right-3 w-9 h-9 bg-[#0a0a0a] border border-white/15 hover:border-white/40 text-white/70 hover:text-white flex items-center justify-center z-10"
          aria-label="Close"
          data-testid="macro-split-modal-close"
        >
          <X className="w-4 h-4" />
        </button>
        <MacroSplitEditor
          kcalTarget={kcalTarget}
          onSaved={() => onOpenChange(false)}
          compact
        />
      </div>
    </div>,
    document.body
  );
}
